const tokenStorage = {};
const getTokenByKey = key => {
  return tokenStorage[key];
};
const setToken = (key, token) => {
  tokenStorage[key] = token;
};
const removeTokenByKey = key => {
  delete tokenStorage[key];
};
const getAccessToken = () => {
  return getTokenByKey('accessToken');
};
const getIdToken = () => {
  return getTokenByKey('idToken');
};
module.exports = {
  getTokenByKey,
  getAccessToken,
  getIdToken,
  setToken,
  removeTokenByKey
};